module.exports = __webpack_public_path__ + "static/media/green-dots-vert.2000832c.svg";